exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".notification__notification___271jm{top:3em;right:0em}", ""]);

// Exports
exports.locals = {
	"notification": "notification__notification___271jm"
};